import { Box } from '@mantine/core'

import { CarouselOrListingBlockProps } from 'components/molecules/carouselOrListingBlock'
import { useIsMobile } from 'hooks/useIsMobile'
import { Article } from 'interfaces/types'

import { CarouselOrListingBlockWrapper } from '../../carouselOrListingBlockWrapper'
import { NormalLayout } from '../normalLayout'
import { SingleAdvanceItem } from '../singleAdvanceItem'

type ArticleCardListProps = {
  articles: Article[]
  dataTrackingCommon: any
  readmoreArticles?: string[]
  processClass?: {
    processRoot: string
    processBar: string
  }
  onSlideChange?: CarouselOrListingBlockProps['onSlideChange']
  adUnitPath?: string
  keepMobileLayoutSameDesktop?: boolean
}
const SliderAdvanceLayout = (props: ArticleCardListProps) => {
  const isMobile = useIsMobile()
  const {
    onSlideChange,
    articles = [],
    dataTrackingCommon,
    adUnitPath,
    keepMobileLayoutSameDesktop,
  } = props
  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      {(!keepMobileLayoutSameDesktop && isMobile) || articles.length <= 5 ? (
        <SingleAdvanceItem
          articles={articles.slice(0, 5)}
          dataTrackingCommon={dataTrackingCommon}
        />
      ) : (
        <CarouselOrListingBlockWrapper
          showFullSlide={!isMobile}
          lengthToCarouselDesktop={2}
          percentOfEndSlideMobile={88}
          lazyLoad
          onSlideChange={onSlideChange}
          carouselSetting={{
            loop: false,
          }}
        >
          <CarouselOrListingBlockWrapper.Slider>
            <>
              {!isMobile && articles.length > 5 && (
                <SingleAdvanceItem
                  articles={articles.slice(0, 5)}
                  dataTrackingCommon={dataTrackingCommon}
                />
              )}
              {(() => {
                const listing = articles.slice(5)
                const perSlide = isMobile ? 4 : 6
                return [
                  ...new Array(Math.ceil(listing.length / perSlide)),
                ].map((_i, idx) => (
                  <NormalLayout
                    key={idx}
                    layout={'list-contain-ads'}
                    articles={listing.slice(
                      idx * perSlide,
                      idx * perSlide + perSlide,
                    )}
                    adUnitPath={adUnitPath}
                    dataTrackingCommon={dataTrackingCommon}
                  />
                ))
              })()}
            </>
          </CarouselOrListingBlockWrapper.Slider>
        </CarouselOrListingBlockWrapper>
      )}
    </Box>
  )
}

export { SliderAdvanceLayout }
